import { compose } from "redux";
import { map, sort } from "../../../helpers/fp";
import { RECEIVE_BRANDS, REQUEST_BRANDS } from "./constants";
import logger from "../../../lib/logger";
import { getBrands } from "../../../lib/api/navigation";
import {
  byKey,
  byTitle,
  titleLinkAndChannelExclusions,
  groupByFirstCharOfTitle
} from "./helpers";

const transformBrands = compose(
  sort(byKey),
  Object.entries,
  groupByFirstCharOfTitle,
  sort(byTitle),
  map(titleLinkAndChannelExclusions)
);

const receiveBrands = json => ({
  type: RECEIVE_BRANDS,
  payload: {
    title: json.content.title,
    groups: transformBrands(json.children)
  }
});

export const fetchBrands = ({
  country = null,
  query = { cid: null },
  uuid = null,
  xSiteOrigin = null
}) => dispatch => {
  dispatch({ type: REQUEST_BRANDS });

  return getBrands({ country, query, uuid, xSiteOrigin })
    .then(response => dispatch(receiveBrands(response[0])))
    .catch(error => {
      error.message = `getBrands failed, and caught error: ${error.message}`;
      logger.error(error);
      if (SERVER) {
        throw error;
      }
    });
};
